// extracted by mini-css-extract-plugin
export default {"wrapper":"pageHeaders_wrapper__EKfYt","page-header-actions":"pageHeaders_page-header-actions__tR0tu","ant-btn-white":"pageHeaders_ant-btn-white__SgChm"};